module.exports = __webpack_public_path__ + "static/media/background.22cabfbc.png";